import styled from "styled-components";


export const StyledHeaderHelpIcon = styled.div`
    margin: 0 0 5px 10px;
`